import React from 'react'
import PropTypes from 'prop-types'

class CheckoutComplete extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.onCompleteCheckout(this.props.placeOrderDetails);
  }

  render() {
    return (
      <div className={`summary-complete-checkout mb-3 ${this.props.additionalClassname && this.props.additionalClassname}`}>
        <a
          href=""
          className='btn btn-orange'
          disabled={this.props.isPlaceOrderPending}
                onClick={(e) => this.onClick(e)}
                style={{ marginTop: '-1rem', display: 'flex' }}
        >
          {this.props.buttonText}
          <span
            style={{
              left: '66%',
              position: 'absolute',
              lineHeight: '1.4em',
              visibility: this.props.isPlaceOrderPending ? 'visible' : 'hidden'
            }}
            className='fa fa-regular fa-spin fa-spinner-scale fa-fw'></span>
        </a>
      </div>
    );
  }
}

CheckoutComplete.propTypes = {
  onCompleteCheckout: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  placeOrderDetails: PropTypes.object.isRequired,
  additionalClassname: PropTypes.string,
  isPlaceOrderPending: PropTypes.bool
}



export default CheckoutComplete